<template>
  <v-main class="main"> 
    <v-container fluid class="container">
      <div class="main-content">
        <transition name="slide" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
      <div class="snackbar">
        <v-scroll-y-reverse-transition>
          <SnackBar v-if="resource.status"/>
        </v-scroll-y-reverse-transition> 
      </div>

      <section class="layout__footer">
      <span>© Todos os Direitos Reservados - SESAB</span><br>
      <span class="font-bold">{{ version }}</span>
    </section>
    </v-container> 
  </v-main>
</template>

<script>
import SnackBar from '../widgets/SnackBar-comp.vue';
import packageJson from "@/../package.json"; 
import { VScrollYReverseTransition } from 'vuetify/lib';
import { mapGetters } from "vuex";

export default {

    data () {
      return {
        snackbar: false,
      }
    },

    computed:{
      ...mapGetters({
            resource: "getSnackBarData"
        }),

        version() {
          return packageJson.version;
        },
    },

    components: {
       SnackBar,
       VScrollYReverseTransition
    },

    methods:{
      toggleTest(){
        return this.snackbar = !this.snackbar;
      }
    }

};
</script>

<style scoped>
.main {
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(
    14deg,
    #b4dac7 0%,
    #fefffed5 100%
  );
  background-color: rgb(190, 223, 197);
}

.container {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding: 40px 20px !important;
}

.container > .main-content {
  flex: 1;
  background: #ffffff00; 
  border-radius: 8px;
  border: 8px;
}

.slide-enter,
.slide-leave-to {
  transform: translate(-50px);
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s;
}

.snackbar{
  position: absolute;
  bottom: 0;
  right: 0;
  padding-right: 1rem;
  padding-bottom: 1rem;
}

.layout__footer {
  text-align: center;
  padding-bottom: 10px;
  font-size: 0.9rem;
  color: #555;
  margin-top: 10px;
}
</style>
